import { MatDialog } from '@angular/material/dialog';
import {
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  DoCheck,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.states';
import { Subject } from 'rxjs';
import { OverlayService } from 'src/app/shared/modules/overlay/services/overlay.service';
import { InvestInInvoiceComponent } from '../invest-in-invoice/invest-in-invoice.component';
import { take, takeUntil } from 'rxjs/operators';
import { UsersSelectors } from 'src/app/features/users/state/users.selector-types';
import { InvoiceSelectors } from 'src/app/features/invoices/state/invoices.selector-types';
import { WindowScrollService } from 'src/app/shared/services/window-scroll.service';
import { cloneDeep } from 'lodash';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { ActivatedRoute } from '@angular/router';
import { PendingValidationPopupComponent } from 'src/app/shared/UI/organisms/pending-validation-popup/pending-validation-popup.component';
import { UserStatus } from 'src/app/shared/enums/UserStatus.enum';
@Component({
  selector: 'app-opportunities-list',
  templateUrl: './opportunities-list.component.html',
  styleUrls: ['./opportunities-list.component.scss'],
})
export class OpportunitiesListComponent implements OnInit, OnDestroy, AfterViewInit, DoCheck {
  ngUnsubscribe: Subject<void> = new Subject<void>();
  invoices = [];
  opportunities = [];
  opportunitiesNotPublished;
  displayToggle = true;
  currency = 'pen';
  default = true;
  toggle = 'pen';
  tabPulished = true;
  tabNotPulished = false;

  tabOpportunities = '0';
  opportunitiesToggle = false;
  notPublishedToggle = false;
  firtsLabel = 'PEN';
  secondLabel = 'USD';
  notPublishedcurrency = 'pen';
  opportunitiesCurrency = 'pen';
  opportunitiesCount = 0;
  opportunitiesNotPublishedCount = 0;

  selected = 0;
  @Output() openNewTabTest = new EventEmitter();
  constructor(
    private overlayService: OverlayService,
    private store: Store<AppState>,
    private windowScrollService: WindowScrollService,
    private cdRef: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private route: ActivatedRoute
  ) {}
  userStatus = '';
  isDisclaimerVisible = false;
  scrollVisibility = false;
  scrollVisibilityNotPublished = false;
  scrollDismissed = false;
  lastScrollPosition = 0;
  dontTriggerTabEvent = false;
  isMobile;
  loggedInUserRole;
  @ViewChild('invoicesList') invoicesList: ElementRef;

  ngOnInit() {
    this.store
      .select(UsersSelectors.profileProperty('role'))
      .pipe(take(1))
      .subscribe(role => (this.loggedInUserRole = role));

    const currencyValue = this.route.snapshot.queryParamMap.get('currency');
    if (this.loggedInUserRole === 'investor' && (currencyValue === 'usd' || currencyValue === 'pen')) {
      this.setCurrencyOnInit(currencyValue);
    }

    this.store
      .select(InvoiceSelectors.allOpportunities)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data): any => {
        this.invoices = data;

        this.filterOpportunities();

        this.totalByCurrency();
        this.getTabLocalStorage();
      });

    this.store
      .select(UsersSelectors.profileProperty('status'))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(status => {
        this.userStatus = status;
      });

    this.store
      .select(UsersSelectors.profileProperty('isApprovedDismissed'))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(isApprovedDismissed => {
        this.isDisclaimerVisible = !isApprovedDismissed;
      });

    this.overlayService.getCloseEmitter().subscribe(obs => {
      if (obs && obs === 'OpportunityDetail') {
        this.sendEventPageView(this.currency);
        this.defaultLauncher();
      }
    });

    this.getLocalStorage();
    this.getDefaultToggle();

    this.breakpointObserver.observe([Breakpoints.XSmall]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isMobile = true;
        this.defaultLauncher();
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.lastScrollPosition) {
        window.scrollTo(0, this.lastScrollPosition);
      }

      this.windowScrollService.scrollY.subscribe(e => {
        if (e >= 80) {
          this.scrollDismissed = true;
        }
        localStorage.setItem('opportunities_scroll', document.documentElement.scrollTop.toString());
      });
    }, 1000);
  }

  ngDoCheck() {
    this.setScrollVisibility();
    this.cdRef.detectChanges();
  }

  setScrollVisibility() {
    this.scrollVisibility = false;
    this.scrollVisibilityNotPublished = false;
    let body = document.body;
    let html = document.documentElement;

    const scrollSize = html.scrollHeight - html.clientHeight;

    if (scrollSize >= 50 && this.selected === 0) {
      this.scrollVisibility = true;
    }

    if (scrollSize >= 50 && this.selected === 1) {
      this.scrollVisibilityNotPublished = true;
    }
  }

  showInvest(invoice) {
    let selectedInvoiceCopy = cloneDeep(invoice);
    selectedInvoiceCopy.parentTab = this.getTabName();
    this.overlayService.showComponent(InvestInInvoiceComponent, selectedInvoiceCopy);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setCurrencyOnInit(initialCurrency: any) {
    this.opportunitiesCurrency = initialCurrency;
    this.notPublishedcurrency = initialCurrency;
    this.setCurrencyLocalStorage('opportunities_tab');
    this.setCurrencyLocalStorage('not_published_tab');
    // this.dontTriggerTabEvent = true;
    // this.scrollDismissed = false;
    // this.sendEventPageView(this.currency);
  }

  sendEventPageView(currency: string) {
    this.windowScrollService.sendNewEvent('Opportunities', `Overview`, this.getTabName(), currency.toUpperCase());
  }

  setCurrencyOpportunies($event: any) {
    this.opportunitiesCurrency = $event;
    this.setCurrencyLocalStorage('opportunities_tab');
    this.filterOpportunities();
    this.totalByCurrency();
  }

  setCurrencyNotPublished($event: any) {
    this.notPublishedcurrency = $event;
    this.setCurrencyLocalStorage('not_published_tab');
    this.filterOpportunities();
    this.totalByCurrency();
  }

  setCurrencyLocalStorage(tabName: string) {
    if (tabName === 'opportunities_tab') {
      localStorage.setItem('opportunities_toggle_currency', this.opportunitiesCurrency);
    } else {
      localStorage.setItem('not_published_toggle_currency', this.notPublishedcurrency);
    }
  }

  getLocalStorage() {
    const opportunitiesToggle = localStorage.getItem('opportunities_toggle_currency');
    const notPublishedToggle = localStorage.getItem('not_published_toggle_currency');

    if (opportunitiesToggle) {
      this.opportunitiesCurrency = opportunitiesToggle;
    }
    if (notPublishedToggle) {
      this.notPublishedcurrency = notPublishedToggle;
    }

    if (this.selected === 0 && opportunitiesToggle) {
      this.filterOpportunities();
      this.totalByCurrency();
    }
    if (this.selected === 1 && notPublishedToggle) {
      this.filterOpportunities();
      this.totalByCurrency();
    }

    this.lastScrollPosition = Number(localStorage.getItem('opportunities_scroll')) || 0;
  }

  getDefaultToggle() {
    this.opportunitiesCurrency == 'pen' ? (this.opportunitiesToggle = false) : (this.opportunitiesToggle = true);
    this.notPublishedcurrency == 'pen' ? (this.notPublishedToggle = false) : (this.notPublishedToggle = true);
  }

  getTabLocalStorage() {
    this.tabOpportunities = localStorage.getItem('tab-opportunities');
    if (this.tabOpportunities) {
      this.selected = Number(this.tabOpportunities);
    } else {
      this.selected = 0;
    }
  }

  filterOpportunities() {
    if (!this.invoices) {
      this.opportunities = [];
      this.opportunitiesNotPublished = [];
      return;
    }
    const opportunities = this.invoices.filter(op => op.onSale === undefined || op.onSale);
    const notPublishedOpportunities = this.invoices.filter(op => op.onSale !== undefined && !op.onSale);

    const opportunitiesByCurrency = opportunities.filter(op => op.currency === this.opportunitiesCurrency);
    const notPublishedByCurrency = notPublishedOpportunities.filter(op => op.currency === this.notPublishedcurrency);

    this.opportunities = opportunitiesByCurrency;
    this.opportunitiesNotPublished = notPublishedByCurrency;
    this.opportunitiesCount = opportunities?.length || 0;
    this.opportunitiesNotPublishedCount = notPublishedOpportunities?.length || 0;
  }

  totalByCurrency() {
    let filterList = [];
    if (this.selected === 0) {
      filterList = this.invoices.filter(o => o.onSale === true);
    } else {
      filterList = this.invoices.filter(o => o.onSale === false);
    }

    const opportunitiesByPEN = filterList.filter(oppor => oppor.currency === 'pen')?.length;

    const opportunitiesByUSD = filterList.filter(oppor => oppor.currency === 'usd')?.length;

    this.firtsLabel = '(' + opportunitiesByPEN + ') PEN';
    this.secondLabel = 'USD (' + opportunitiesByUSD + ')';
  }

  openPublished() {
    this.selected = 0;
  }

  openNotPublished() {
    this.selected = 1;
  }

  updateTabSelected($event) {
    this.selected = $event;
    localStorage.setItem('tab-opportunities', this.selected.toString());
    this.scrollDismissed = false;
    this.filterOpportunities();
    this.totalByCurrency();

    if (!this.dontTriggerTabEvent) {
      this.sendEventPageView(this.currency);
    } else {
      this.dontTriggerTabEvent = false;
    }
  }

  getTabName() {
    switch (this.selected) {
      case 0:
        return 'Publicadas';
      case 1:
        return 'Por publicar';
      default:
        return 'Publicadas';
    }
  }

  defaultLauncher() {
    if (this.isMobile) {
      this.windowScrollService.setDefaultLauncher(false);
    }
  }
}
